import React, { forwardRef, useImperativeHandle } from "react";
import { useWallpaperRenderer } from "../hooks/useWallpaperRenderer";

/**
 * Displays the interactive Three.js wallpaper preview at 360×800px.
 * Full-resolution rendering is deferred until export.
 *
 * Ref methods:
 *   exportBlob()  — Promise<Blob> of the current full-res frame
 *   renderer      — WallpaperRenderer instance
 */
const WallpaperCanvasPreview = forwardRef(function WallpaperCanvasPreview(
  { bgSrc, fgSrc, clockSettings, style },
  ref
) {
  const { containerRef, exportBlob, rendererRef } = useWallpaperRenderer(
    bgSrc,
    fgSrc,
    clockSettings
  );

  useImperativeHandle(ref, () => ({
    exportBlob,
    get renderer() { return rendererRef.current; },
  }));

  return (
    <div
      ref={containerRef}
      style={{
        width: 360,
        height: 800,
        overflow: "hidden",
        position: "relative",
        flexShrink: 0,
        ...style,
      }}
    />
  );
});

export default WallpaperCanvasPreview;
